var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShimian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631316",
    x: 2.875,
    y: 2.375,
    width: 11.3125,
    height: 11.25,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 33",
    x1: 0.5,
    y1: 2.5,
    x2: 16.5,
    y2: 2.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 34",
    x1: 0.5,
    y1: 13.5,
    x2: 16.5,
    y2: 13.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 35",
    x1: 14.0625,
    y1: 2.18557e-8,
    x2: 14.0625,
    y2: 16,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 36",
    x1: 3.0625,
    y1: 2.18557e-8,
    x2: 3.0625,
    y2: 16,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 37",
    x1: 3.14645,
    y1: 6.5527,
    x2: 7.0527,
    y2: 2.64645,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 38",
    x1: 3.14645,
    y1: 9.59957,
    x2: 10.3105,
    y2: 2.43551,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 40",
    x1: 5.09957,
    y1: 13.6464,
    x2: 14.2402,
    y2: 4.50582,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 41",
    x1: 8.32418,
    y1: 13.4179,
    x2: 14.2402,
    y2: 7.50192,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 42",
    x1: 11.1313,
    y1: 13.5688,
    x2: 14.2402,
    y2: 10.4599,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 39",
    x1: 3.14645,
    y1: 12.5996,
    x2: 13.3418,
    y2: 2.40426,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShimian);
export default __webpack_public_path__ + "static/media/shimian.922d697c1077d1b725960e6f559b15ac.svg";
export { ForwardRef as ReactComponent };